import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import UserPermission from "../models/UserPermission";

class UserPermissionManager extends ManagerBase {
	constructor () {
		super("userPermissionManager");
		this.remoteClassName = "user-permission";
		this.localClassType = UserPermission;
	}

	getListByActivityGuid (activityGuid) {
		const requestedAction = "get-list-by-activity-guid";

		if (Shark.$store.workOfflineMode) {
			return Promise.resolve({
				data: [],
				requestedAction,
				status: "workOffline",
			});
		}
		else {
			if (Shark.$store.onLine) {
				const rd = NousCore.api.createRequest({ item: { activityGuid } });

				return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
				.then(data => {
					if (data.isSuccess) {
						switch (data.rc) {
							case 1:
								return {
									data: data.items,
									requestedAction,
									status: "ok",
								};
							case 99:
								return {
									data,
									requestedAction,
									status: "ko",
								};
						}
					}
				});
			}
			else {
				return Promise.resolve({
					data: [],
					requestedAction,
					status: "offline",
				});
			}
		}
	}

	getListByProjectGuid (projectGuid) {
		const requestedAction = "get-list-by-project-guid";

		if (Shark.$store.workOfflineMode) {
			return Promise.resolve({
				data: [],
				requestedAction,
				status: "workOffline",
			});
		}
		else {
			if (Shark.$store.onLine) {
				const rd = NousCore.api.createRequest({ item: { projectGuid } });

				return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
				.then(data => {
					if (data.isSuccess) {
						switch (data.rc) {
							case 1:
								return {
									data: data.items,
									requestedAction,
									status: "ok",
								};
							case 99:
								return {
									data,
									requestedAction,
									status: "ko",
								};
						}
					}
				});
			}
			else {
				return Promise.resolve({
					data: [],
					requestedAction,
					status: "offline",
				});
			}
		}
	}

	async getActiveForUserByActivityGuid (activityGuid) {
		const requestedAction = "get-active-for-user-by-activity-guid";
		const rd = NousCore.api.createRequest({ item: { activityGuid } });

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: Shark.getInstanceList(this.localClassType, data.items),
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getActiveForUserByProjectGuid (projectGuid) {
		const requestedAction = "get-active-for-user-by-project-guid";
		const rd = NousCore.api.createRequest({ item: { projectGuid } });

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: Shark.getInstanceList(this.localClassType, data.items),
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getListByUserGuid (userGuid) {
		const requestedAction = "get-list-by-user-guid";
		const rd = NousCore.api.createRequest({ item: { userGuid } });

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});

	}
}

const userPermissionManager = new UserPermissionManager();

Shark.registerController(userPermissionManager);

export default userPermissionManager;
